import { NationalityRepository } from '../../domain/repository';
import { NationalityRepositoryImpl } from '../repository';

export const nationalityProviders = [
  {
    provide: NationalityRepository,
    useExisting: NationalityRepositoryImpl,
  },
];


